import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求标签列表
export const getpriseList = params => {
    return get("/admin/enterprise", params);
};
// // 添加权限
export const addprise = params => {
    return post("/admin/enterprise", params);
};
// 修改信息
export const editprise = params => {
    return put(`/admin/enterprise/${params.id}`, params);
};
// 删除权限
export const deleteprise = params => {
    return del(`/admin/enterprise/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/enterprise.js